import { render, staticRenderFns } from "./SimpleOSMAddress.vue?vue&type=template&id=819725c6&scoped=true"
import script from "./SimpleOSMAddress.vue?vue&type=script&lang=js"
export * from "./SimpleOSMAddress.vue?vue&type=script&lang=js"
import style0 from "./SimpleOSMAddress.vue?vue&type=style&index=0&id=819725c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "819725c6",
  null
  
)

export default component.exports